export default __webpack_public_path__ + "static/media/Analog_2_Pin_Output@2x.c93e9305.png";